module.exports = __webpack_public_path__ + "img/sale3.121e05ef.png";